import {
  OperationalEntity,
  OperationalEntityInput
} from "@common-core/coat-operational-hierarchy-appsync-model";

export const toOperationalEntityInput = (
  entity: OperationalEntity
): OperationalEntityInput => {
  return {
    parentId: entity.parent?.id,
    sources: entity.sources || [],
    organizationInformation: {
      address: {
        streetAddressLine1: entity.dealerInformation?.address?.street,
        streetAddressLine2:
          entity.dealerInformation?.address?.streetAddressLine2,
        city: entity.dealerInformation?.address?.city,
        state: entity.dealerInformation?.address?.state,
        country: entity.dealerInformation?.address?.country,
        zip: entity.dealerInformation?.address?.zip
      },
      dbaName: entity.dealerInformation?.dbaName || "",
      legalName: entity.dealerInformation?.legalName,
      status: entity.dealerInformation?.status,
      telecomNumbers: entity.dealerInformation?.primaryPhone
        ?.split(",")
        .map(number => number.trim())
    },
    oems: entity.oems || []
  };
};
